import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export default function ImageViewer({ src, alt, onClose }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Trigger animation frame
        requestAnimationFrame(() => setIsVisible(true));

        // Lock body scroll
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Wait for animation
    };

    if (!src) return null;

    return createPortal(
        <div
            className={`fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm transition-opacity duration-300 ${isVisible ? "opacity-100" : "opacity-0"
                }`}
            onClick={handleClose}
        >
            <div
                className={`relative max-w-[90vw] max-h-[90vh] transition-transform duration-300 scale-95 ${isVisible ? "scale-100" : "scale-90"
                    }`}
                onClick={(e) => e.stopPropagation()} // Prevent close when clicking image
            >
                <img
                    src={src}
                    alt={alt || "Profile"}
                    className="rounded-lg shadow-2xl max-w-full max-h-[85vh] object-contain border border-white/10"
                />

                {/* Close Button */}
                <button
                    onClick={handleClose}
                    className="absolute -top-12 right-0 md:-right-12 text-white/80 hover:text-white transition-colors bg-white/10 hover:bg-white/20 rounded-full p-2"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>

                {/* Caption */}
                {alt && (
                    <div className="absolute -bottom-10 left-0 w-full text-center text-white/90 font-medium text-lg drop-shadow-md">
                        {alt}
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
}
